export type TSettingForm = {
  irohanaSystemNotificationEmail: string;
  clientSystemNotificationEmail: string;
};

export const settingFormInitValues: TSettingForm = {
  irohanaSystemNotificationEmail: "",
  clientSystemNotificationEmail: "",
};
